import CustomLink from "@Components/CustomLink";
import Image from "@Components/Image";
import styles from "./StatesSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";

type StateItem = {
  name: string;
  canonical_name: string;
  parent_name?: string;
  images?: { path: string; type?: string; caption?: string }[];
};

type StatesSectionProps = {
  countryName: string;
  stateList: StateItem[];
  isDesktop?: boolean;
  title?: string;
  className?: string;
};

const DEFAULT_STATE_IMAGE =
  "https://prod-assets.amberstudent.com/regions/Popular-Cities/UK/UK_London_London Eye.webp?w=330&h=330";

const getStateImageUrl = (state: StateItem): string => {
  if (state.images && state.images.length > 0 && state.images[0].path) {
    return state.images[0].path;
  }
  return DEFAULT_STATE_IMAGE;
};

const StatesSection = ({
  countryName,
  stateList,
  isDesktop = false,
  title,
  className,
}: StatesSectionProps) => {
  const { t } = useTranslationHook();

  if (!stateList || stateList.length === 0) {
    return null;
  }

  const displayTitle =
    title ||
    `${t("searchpage.components.statessection.statessectiontitle")} ${
      countryName === "United Kingdom" ? "UK" : countryName
    }`;

  return (
    <>
      <div
        className={formatClassNames(
          isDesktop ? styles.statesContainer : styles.statesContainerMobile,
          className,
        )}
      >
        <h2 className={styles.title}>{displayTitle}</h2>
        <div className={isDesktop ? styles.statesGrid : styles.statesCarousel}>
          {stateList.map((state) => (
            <CustomLink
              key={state.canonical_name}
              to={`/places/search/${state.canonical_name}`}
              className={isDesktop ? styles.stateCard : styles.stateCardMobile}
            >
              <div className={styles.imageWrapper}>
                <Image
                  src={getStateImageUrl(state)}
                  alt={state.name}
                  className={styles.stateImage}
                  width="100%"
                  height="100%"
                />
                <div className={styles.overlay} />
              </div>
              <div className={styles.stateName}>{state.name}</div>
            </CustomLink>
          ))}
        </div>
      </div>
      {!isDesktop && <div className={styles.bottomBorder} />}
    </>
  );
};

export default wrapperHOC(StatesSection, {
  componentName: "StatesSection-Search",
  showForChina: true,
});
